export const ICON_COLOR = 'interactive-kg-blue';
export const SMALL_ICON = 'small';
export const SMALL_DESCRIPTION = 'small';
export const ARIA_HIDDEN_ICON_PROPERTY = 'true';
export const BUTTON_VARIANT = 'primary';
export const BUTTON_SIZE = 'large';
export const BUTTON_TYPE = 'button';
